<template>
    <v-row>
        <v-col>
            <v-row justify="center">
                <v-card width="45%"  flat class="mt-10">
            
                <v-form>
                    <v-text-field
                        v-model="id"
                        label="menu id"
                        outlined
                        dense
                        color="primary"
                    ></v-text-field>
                    <v-text-field
                        v-model="name"
                        label="menu name"
                        outlined
                        dense
                        color="primary"
                    ></v-text-field>
                    <v-text-field
                        v-model="price"
                        label="price"
                        outlined
                        dense
                        color="primary"
                    ></v-text-field>
                    <v-select
                        
                        class="mt-6"
                        :items="items"
                        label="Catorgory"
                        v-model="catagory"
                    ></v-select>
                    <v-textarea
                        class="mt-6"
                        outlined
                        v-model="description"
                        label="Menu description"
                    ></v-textarea>
                    <v-btn width="100%" color="primary" @click="submit">Submit</v-btn>
                </v-form>


                </v-card>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import {mapActions } from "vuex";
export default {
    props: ["menu"],


    data() {
        return {
            
            id: this.menu.id,
            name: this.menu.name,
            price: this.menu.price,
            catagory: this.menu.catagory,
            items: ['Lunch & Dinner', 'Groups & Family Meals', 'Sandwiches', 'Vegetarian Dishes', 'Beverages', 'Appetizers & Sides'],
            description: this.menu.description
        }
    },
    methods: {
        ...mapActions(['updateTextMenu']),
        submit() {
            let menu = {
                menu_id: this.menu._id,
                id: this.id,
                name: this.name,
                price: this.price,
                catagory: this.catagory,
                description: this.description
            }
            this.updateTextMenu(menu).then(result => {
                if(result.data.success) {
                    this.$router.push('/update_text')
                }
            })
            // console.log(menu)
        }
    }, 
    computed: {
        src: function() {
            if(process.env.NODE_ENV === 'production') {
                return "/api/images/image?filename="
            } else {
                return "http://localhost:5000/api/images/image?filename="
            }
        }
    },
}
</script>

<style>
.product-box{
    width: 360px;
    height: 360px;
    margin-top: 25px;
    margin-right: 20px;
    margin-left: 10px;
    border-radius: 6px;
    background-color: white;
    box-shadow: 0 1px 1px 0 rgba(0, 160, 35, 0.4), 0 1px 15px 0 rgba(0, 0, 0, 0.19);
    text-align: center;
    color: #34026a;
  }

  .product-box-mobile{
    width: 160px;
    height: 260px;
    margin-top: 15px;
    margin-right: 6px;
    margin-left: 6px;
    background-color: white;
    text-align: center;
    font-size: 16px;
    color: #34026a;
  }
  .product-title{
    text-align: center;
    font-size: 12px;
    font-style: italic;
    font-family: monospace;
    color: grey;
     
  }

  .product-title-mobile{
    
    font-size: 12px;
    color:black;
    
  }
  .menu-name {
      color: gray;
      font-size: 26px;
      font-style: normal;
      font-stretch: expanded;
      font-weight: 400;
  }
</style>